var render = function render(){var _vm=this,_c=_vm._self._c;return _c('e-chart',{attrs:{"header":`${_vm.documentTitle}`,"options":_vm.chartMSNContainerOptions,"series":_vm.chartMSNContainerSeries,"chartId":"msnContainer","chartRedirectParams":_vm.chartRedirectParams,"chartLoading":_vm.chartLoading,"chartError":_vm.chartError}})
}
var staticRenderFns = []

export { render, staticRenderFns }